<section class="mu-home" *ngIf="!showImport">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row">
            <app-greeting></app-greeting>
            <app-back-button [pageTitle]="pageTitle" [backRouting]="dashboardPageLink"></app-back-button>

           <!--  <div class="col-12 col-md-4 tptxt-gbdpg">
              <h4>Data Repository</h4>
            </div>
 -->
            <div class="col-12 d-flex justify-content-between mb-2">
              <div class="col-4 content-selector-panel d-flex align-items-center">
                <span class="me-3 label-color">View</span>
                <select class="form-select" [value]="id" (change)="onViewSelect($event.target.value)">
                  <option *ngFor="let option of (viewOptions$ | async)" [value]="option.id" [selected]="option.id == id">
                    {{ option.name }}
                  </option>
                </select>
              </div>

              <div class="right-align">
                <button
                  type="button"
                  class="btn-actvtytp text-decoration-none justify-content-end gbdpg-righttxt display-inline"
                  (click)="showImport = !showImport">
                  {{ id == 1 ? "BULK ACTION" :"UPLOAD DOCUMENTS"}}
                </button>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <app-summary-data-table [options]="summaryOptions" [data]="summaryData"></app-summary-data-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div *ngIf="showImport">
  <app-bulk-import [showNavBar]="false" [showLeftMenu]="false" [validator]="importValidator"
    (importClose)="showImport = false" [close]="false"></app-bulk-import>
</div>
